import { useEffect } from "react";
import { TEMPLATES_API } from "../../constants/api";
import { CART_REMINDER, SELECT_TYPE, TEXT_TYPE } from "../../constants/webapp";
import { addSelectItem } from "../../utils/helpers";

export const useTemplatesForm = ({ form, updateFormValues }) => {
  console.log(form);

  useEffect(() => {
    updateFormValues({ active: true });
  }, []);

  const fields = [
    {
      id: "type",
      type: SELECT_TYPE,
      required: true,
      options: [CART_REMINDER].map((item) => addSelectItem({ id: item })),
    },
    {
      id: "title",
      type: TEXT_TYPE,
      required: true,
    },
    {
      id: "body",
      type: TEXT_TYPE,
      required: true,
      props: {
        rows: 4,
      },
    },
  ];

  return {
    fields,
    api: TEMPLATES_API,
  };
};
